import type { RouteLocationNormalized } from 'vue-router';

const CHUNK_RETRY_PREFIX = 'chunk-load-retry';

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  );
}

// Solo reintenta una vez por ruta para evitar loops cuando el chunk sigue fallando tras un deploy.
export function handleChunkLoadError(error: unknown, to: RouteLocationNormalized): void {
  if (!isChunkLoadError(error)) return;

  const retryKey = `${CHUNK_RETRY_PREFIX}:${to.fullPath}`;

  if (sessionStorage.getItem(retryKey)) {
    sessionStorage.removeItem(retryKey);
    return;
  }

  sessionStorage.setItem(retryKey, '1');
  window.location.assign(to.fullPath);
}
